export type FeaturePage = {
  slug: string;
  title: string;
  description: string;
  path: string;
  isPickup: boolean;
  isPublished: boolean;
};

export const FEATURE_PAGES: FeaturePage[] = [
  {
    slug: 'jhs-free-print',
    title: '高校受験向け：中学の無料プリント特集',
    description:
      '中学5教科の無料プリントサイトをまとめて紹介。高校受験や定期テスト対策に役立つサイトを厳選しました。',
    path: '/features/jhs-free-print',
    isPickup: true,
    isPublished: true,
  },
  {
    slug: 'math-summary',
    title: '中学数学まとめ｜無料教材・単元別学習ガイド',
    description:
      '中学数学の学習内容を学年別・単元別に整理。つまずきやすいポイント、おすすめの無料教材サイト、居場所や家庭での使い方をまとめて紹介します。',
    path: '/features/math-summary',
    isPickup: true,
    isPublished: true,
  },
  {
    slug: 'english-summary',
    title: '中学英語まとめ｜無料教材・文法整理ガイド',
    description:
      '中学英語の学習内容を学年別・文法別に整理。つまずきやすいポイント、おすすめの無料教材サイト、居場所や家庭での使い方をまとめて紹介します。',
    path: '/features/english-summary',
    isPickup: true,
    isPublished: true,
  },
  {
    slug: 'japanese-summary',
    title: '中学国語まとめ｜無料教材・読解力向上ガイド',
    description:
      '中学国語の学習内容を学年別・分野別に整理。つまずきやすいポイント、おすすめの無料教材サイト、居場所や家庭での使い方をまとめて紹介します。',
    path: '/features/japanese-summary',
    isPickup: true,
    isPublished: true,
  },
  {
    slug: 'science-summary',
    title: '中学理科まとめ｜無料教材・分野別学習ガイド',
    description:
      '中学理科の学習内容を学年別・分野別に整理。つまずきやすいポイント、おすすめの無料教材サイト、居場所や家庭での使い方をまとめて紹介します。',
    path: '/features/science-summary',
    isPickup: true,
    isPublished: true,
  },
  {
    slug: 'social-summary',
    title: '中学社会まとめ｜無料教材・地理歴史公民ガイド',
    description:
      '中学社会の学習内容を学年別・分野別に整理。つまずきやすいポイント、おすすめの無料教材サイト、居場所や家庭での使い方をまとめて紹介します。',
    path: '/features/social-summary',
    isPickup: true,
    isPublished: true,
  },
];
